import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
//
import enLocales from './en.json';
import deLocales from './de.json';
import frLocales from './fr.json';
import zhLocales from './zh.json';
import cnLocales from './cn.json';
// ----------------------------------------------------------------------

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enLocales },
      english: { translations: enLocales },
      de: { translations: deLocales },
      fr: { translations: frLocales },
      zh: { translations: zhLocales },
      cn: { translations: cnLocales }
    },
    lng: localStorage.getItem('i18nextLng') || 'zh',
    fallbackLng: 'en',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
